<template>
    <main id="main" class="w-screen flex page" :class="{'has-menu': !!role}">
        <navigation></navigation>
        <div class="flex-grow relative z-0">
            <router-view></router-view>
        </div>
    </main>
</template>

<script>
import Vuex from 'vuex';
import Navigation from './components/navigation/Navigation.vue';


export default {
    name: 'App',

    components: {
        Navigation,
    },

    computed: {
        ...Vuex.mapGetters('profile', {
            role: 'role',
        }),
    },

    methods: {
        ...Vuex.mapActions('profile', {
            getUserProfile: 'getUserProfile'
        }),
    },
    created: function () {
        if(localStorage.getItem('_auth_user')){
            this.getUserProfile().catch(() => {
                this.
                this.$router.push({
                    name: 'signIn'
                });
            });
        }
    }
}
</script>
